import React, { useEffect, useState } from 'react'
import { TextField, MenuItem } from '@mui/material'
import { FlowVas } from '../../interfaces/FlowVas/FlowVas'
import { useFlowVas } from '../../hooks/useFlowVas'

interface FlowVasDDLProps {
  onChange: any
  value: any
  type?: 'outlined' | 'filled' | 'standard' | undefined
  fullWidth?: boolean
  valueKey?: 'flowVasId' | 'name'
  required?: boolean
  disabled?: boolean
  size?: 'small' | 'medium' | undefined
}

export const FlowVasDDL: React.FC<FlowVasDDLProps> = ({
  onChange,
  value,
  type,
  fullWidth = false,
  valueKey = 'flowVasId',
  required = false,
  disabled = false,
  size
}) => {
  const [hasError, setHasError] = useState<boolean>(false)

  const {
    flowVasState: { flowVas },
    getFlowVas
  } = useFlowVas()

  useEffect(() => {
    if (flowVas?.length === 0) {
      getFlowVas()
    }
  }, [])

  useEffect(() => {
    // Validar si es obligatorio y si se ha seleccionado alguna opción
    if (required && value < 1) {
      setHasError(true)
    } else {
      setHasError(false)
    }
  }, [value, required])

  const arrFlowVas =
    flowVas !== undefined
      ? flowVas.map((option: FlowVas) => (
          <MenuItem key={option[valueKey]} value={option[valueKey]}>
            {option.name}
          </MenuItem>
        ))
      : []

  return (
    <TextField
      variant={type}
      id='flowVasId'
      name='flowVasId'
      select
      value={value}
      onChange={onChange}
      fullWidth={fullWidth}
      disabled={disabled}
      size={size}
      error={hasError}
      helperText={hasError ? 'Seleccionar Proceso' : undefined}
    >
      <MenuItem key={0} value={0}>
        {'Seleccione Proceso ...'}
      </MenuItem>
      {arrFlowVas}
    </TextField>
  )
}
